import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  assignAuditButton: {
    description:
      'Button label for Assign Audit in the Inventory Grid Header. "{count}" is the number of selected rows; the count suffix is hidden when no rows are selected.',
    defaultMessage: '{count, plural, =0 {Assign Audit} one {Assign Audit (#)} other {Assign Audit (#)}}',
    id: '//9W2J',
  },
  assignAuditButtonRootViewTooltip: {
    description: 'Tooltip for Assign Audit button when viewing inventory across all warehouses',
    defaultMessage: 'Audit can be created from Inventory Grid for a Specific Warehouse',
    id: '53SRqN',
  },
  assignAuditButtonNoProductsTooltip: {
    description: 'Tooltip for Assign Audit button when no inventory rows are selected',
    defaultMessage: 'Select some products to assign an audit',
    id: 'r9THrb',
  },
  assignAuditModalTitle: {
    description: 'Title for the Assign Audit modal',
    defaultMessage: 'Assign Audit',
    id: 'ylWuQA',
  },
  assignAuditModalConfirmButton: {
    description: 'Confirm button label in the Assign Audit modal',
    defaultMessage: 'Create audit',
    id: 'lx9yHc',
  },
  assignAuditCreateSuccess: {
    description: 'Notification title shown when a stock audit is created successfully',
    defaultMessage: 'Audit created',
    id: 'Xr/XuY',
  },
  assignAuditCreateError: {
    description: 'Notification title shown when creating a stock audit fails',
    defaultMessage: 'Failed to create audit',
    id: 'pSCz9k',
  },
  assignAuditCreateErrorGenericContent: {
    description: 'Notification content shown when creating a stock audit fails for an unknown reason',
    defaultMessage: 'Something went wrong. Please try again.',
    id: 'h8Dsu5',
  },
  assignAuditCreateErrorNotFoundContent: {
    description: 'Notification content shown when creating a stock audit fails because one or more products or locations were not found',
    defaultMessage: 'Some of the selected products or locations could not be found. Refresh the page and try again.',
    id: 'rmNNhb',
  },
  assignAuditCreateErrorActiveConflictContent: {
    description:
      'Notification content shown when creating a stock audit fails because one or more selected SKUs already have an active audit',
    defaultMessage: 'One or more selected SKUs already have an active audit. Remove them from the selection and try again.',
    id: 'JquSlf',
  },
  assignAuditModalSummary: {
    description: 'Summary message at the bottom of the Assign Audit modal, informing how many SKUs will be audited',
    defaultMessage:
      'You are about to create an audit for <b>{count, plural, one {# selected SKU} other {# selected SKUs}}</b>. The audit will then become visible in the ShipStation mobile app',
    id: 'SvquhA',
  },
  assignAuditCreateErrorNoProductsContent: {
    description: 'Notification content shown when no selected products match the current warehouse',
    defaultMessage: 'None of the selected products belong to this warehouse. Please update your selection and try again.',
    id: '39QQsC',
  },
});
